import React, { useEffect, useState } from 'react'
import { generateAxiosInstanceInstitute } from '../hooks/useAuthorizedRequestForInstitute'
import VidyaUpasna from "../assets/VidyaUpasna.jpg";

const PrintStudyMaterialSummary = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const [importStudentList, setImportStudentList] = useState([])
    useEffect(() => {
        let apiUrl = `/institute-report?institute_id=${instituteMasterId}`;

        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                console.log(response.data.data)
                setImportStudentList(response.data.data);
            })
            .catch(error => {
                setImportStudentList(error?.response?.data.result);
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });

    }, []);

    useEffect(() => {
        importStudentList?.sections?.length > 0 && window.print()
    }, [importStudentList])


    const [dateTime, setDateTime] = useState('');

    useEffect(() => {
      const intervalId = setInterval(() => {
        const currentDate = new Date();
        const formattedDate = formatDate(currentDate);
        setDateTime(formattedDate);
      }, 1000); // Update every second
  
      return () => clearInterval(intervalId); // Cleanup on component unmount
    }, []);
  
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      let hour = date.getHours();
      const amOrPm = hour >= 12 ? 'pm' : 'am';
      hour = hour % 12 || 12; // Convert to 12-hour format
      const minutes = date.getMinutes().toString().padStart(2, '0');
  
      return `${day}/${month}/${year} ${hour}:${minutes} ${amOrPm}`;
    };

    return (
        <div className="d-grid gap-2 mt-2">
            <div className='print-header'>
                <div className='inst-logo'>
                    <img src={importStudentList.logoPath}></img>
                </div>
                <h2>{importStudentList.instituteName}</h2>
                <div className='main-logo'>
                    <img src={VidyaUpasna}></img>
                </div>
            </div>
            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                <table class="table">
                    <table class="table">
                        <thead>
                            <tr>
                                {/* <th></th> */}
                                <th scope="col" className='sl_no'>Sr. No.</th>
                                <th scope="col">Section Name</th>
                                <th scope="col">Board </th>
                                <th scope="col">Medium</th>
                                <th scope="col">Contents</th>
                                <th scope='col'>PDF Books</th>
                                <th scope='col'>Ref_Books</th>
                                <th scope='col'>Videos</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                importStudentList?.sections?.length > 0 ?
                                    importStudentList?.sections?.map((std, index) => {
                                        return (
                                            <tr>
                                                {/* <th>{std.isApproved || <input type='checkbox' checked={aprovedStudentData.includes(std.id)} onClick={() => { setAproveStudentData(pre => [...pre, std.id]) }} />}</th> */}
                                                <th scope="row" className='sl_no'>{index + 1}</th>
                                                <td>{std.sectionName}</td>
                                                <td>{std.boardName}</td>
                                                <td>{std.streamName}</td>
                                                <td>{std.contactNumber}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>
                                                </td>
                                            </tr>
                                        )
                                    })
                                    :
                                    (<tr>
                                        <th colspan={"100%"} style={{ textAlign: 'center' }}>No Students Available</th>

                                    </tr>)
                            }
                        </tbody>
                    </table>
                    <tbody>
                    </tbody>
                </table>
            </div>
            <div className='print-footer'>
                <p>{dateTime}</p>
                <p>Institute Head Name</p>
            </div>
        </div>
    )
}

export default PrintStudyMaterialSummary